export const SUPPORT_EMAIL =
  (import.meta.env.VITE_SUPPORT_EMAIL as string | undefined) ?? "support@zindeal.com";

export const SECURITY_EMAIL =
  (import.meta.env.VITE_SECURITY_EMAIL as string | undefined) ?? "security@zindeal.com";

export const SALES_EMAIL =
  (import.meta.env.VITE_SALES_EMAIL as string | undefined) ??
  "mdbryant@zebisointelligence.com";

export const STATUS_PAGE_URL =
  (import.meta.env.VITE_STATUS_PAGE_URL as string | undefined) ??
  "https://status.zindeal.com";

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
export const SECURITY_MAILTO = `mailto:${SECURITY_EMAIL}`;
export const SALES_MAILTO = `mailto:${SALES_EMAIL}`;

/** Opens the user's mail client to the founder sales inbox. */
export function salesInquiryHref(subject = "Zindeal inquiry"): string {
  return `${SALES_MAILTO}?subject=${encodeURIComponent(subject)}`;
}
